import { render, staticRenderFns } from "./ClientSearchAreaOrder.vue?vue&type=template&id=24769c00&scoped=true&"
import script from "./ClientSearchAreaOrder.vue?vue&type=script&lang=js&"
export * from "./ClientSearchAreaOrder.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchAreaOrder.vue?vue&type=style&index=0&id=24769c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24769c00",
  null
  
)

export default component.exports